<template>
  <div class="ly1" style="position: relative" v-show="contentShow">
    <div class="noDateShow" v-if="noDateShow && !projectCheck">暂无数据</div>
    <RollLegend class="rollLegend" fontColor="black" legendType="2" @childExam="getIcvExam"></RollLegend>
    <LeftList :data="leftData" :keyMap="keyMap" />
    <div class="ly1-right">
      <el-radio-group
        v-if="joinType"
        class="radioGroup"
        v-model="period"
        size="medium"
        @change="periodChange"
      >
        <el-radio-button label="0">查看整体压实分布</el-radio-button>
        <el-radio-button label="1">查看截面压实过程</el-radio-button>
        <!-- <el-radio-button label="2">按月</el-radio-button> -->
      </el-radio-group>
      <div class="ZHSet" v-show="setShow == JMShow">
        <span>桩号：</span>
        <span>K</span>
        <el-input
          @input="change($event)"
          type="text"
          v-model="ZHFirst"
        ></el-input>
        <span>+</span>
        <el-input
          @input="change($event)"
          type="text"
          v-model="ZHLast"
        ></el-input>
        <el-button type="primary" @click="getIcvSection">定位</el-button>
      </div>
      <ChartLine
        v-show="setShow == JMShow"
        :chartOption="chartOptionJ"
      />
      <heatMap
        @childLine="getIcvView"
        v-if="setShow == 0 && !icvImageUrl"
        :chartOption="chartOption"
        :contentShow="contentShow"
      />
      <div v-if="icvImageUrl" class="imgCon">
        <!-- <el-button type="primary" class="checkDetail" @click="showDetail">查看详情</el-button> -->
        <el-image 
          style="width: 100%; height: 97%"
          :src="icvImageUrl" 
          fit="scale-down"
          @load="getIcvImg"
          :preview-src-list="srcList">
          <div slot="error" class="image-slot">
            暂无数据
          </div>
        </el-image>
      </div>  
    </div>
    <el-dialog width="1600px" custom-class="mapdialog" title="压实度详情" :visible.sync="dialogMapVisible">
      <heatMap ref="heatmap" v-if="dialogMapVisible" :chartOption="chartOption" :contentShow="false"/>
    </el-dialog>
  </div>
</template>

<script>
import { unique,compress } from "../../../../utils/commons";
import LeftList from "../../../../components/layout/leftList";
// import Rolling from "../../../../components/chart/rolling";
import RollLegend from "../rollLegend";
import heatMap from "../../../../components/chart/heatMap";
import ChartLine from "../../../../components/chart/line4";
import { rollingQualityIcvSection } from "../../../../utils/api";
export default {
  data() {
    return {
      setShow: 0,
      JMShow: 0,
      ZHFirst: "",
      ZHLast: "",
      leftData: {},
      chartOption: {},
      keyMap: {
        max: ["最大值"],
        min: ["最小值"],
        average: ["平均值"],
        standardDiff: ["标准差"],
        passRate: ["合格率"],
        overRate: ["过压率"],
        lackRate: ["欠压率"],
      },
      dataValue: "",
      contentShow: true,
      setData: "",
      period: "0",
      joinType: true,
      chartOptionJ: {},
      noDateShow: false,
      getIcv_view:'',
      dialogMapVisible:false,
      srcList:[]
    };
  },
  props: {
    rollingIcvData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    activeIndex1Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    workId: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    joinTypeV: {
      type: Number,
      default: function () {
        return 1;
      },
    },
    projectCheck: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    icvImageUrl: {
      type: String,
      default: function(){
        return ''
      }
    }
  },
  watch: {
    rollingIcvData: function (newValue) {
      console.log(newValue,'newValue')
      if(newValue == null){
        this.noDateShow = true
        this.setData = newValue;
        this.getData(this.setData);
      }
      else if(newValue.data == null||newValue.data.length == 0){
        this.noDateShow = true
        this.setData = newValue;
        this.getData(this.setData);
      }else{
        this.noDateShow = false
        this.setData = newValue;
        this.getData(this.setData);
        this.dataValue = newValue;
      }
    },
    icvImageUrl(newV){
      this.srcList=[newV]
    },
    activeIndex1Code: {
      handler(newVal) {
        console.log(newVal);
        let that = this
        // setTimeout(()=>{
        that.JMShow = 1;
        if (newVal == 1) {
          that.contentShow = true;
          if(this.period==0){
            let obj=JSON.parse(JSON.stringify(this.chartOption))
            this.chartOption={}
            setTimeout(()=>{
              this.chartOption=obj
            },1)
          }
        } else {
          that.contentShow = false;
        }
        // },10)
      },
      deep: true,
      // immediate: true,
    },
    joinTypeV:{
      handler(newVal) {
        if (newVal == 0) {
          this.joinType = false;
        } else {
          this.joinType = true;
        }
      },
      deep: true,
    }
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  created() {},
  mounted() {
    if (this.joinTypeV == 0) {
      this.joinType = false;
    }
  },
  beforeDestroy() {
    this.$store.commit("setIcv_view");
    this.$store.commit("setIcv_exam");
  },
  methods: {
    showDetail(){
      this.dialogMapVisible=true
      let oriChartOption=JSON.parse(JSON.stringify(this.chartOption))
      this.chartOption={}
      setTimeout(()=>{
        this.chartOption=oriChartOption
      },500)
    },
    getIcvView(e) {
      this.$store.commit("setIcv_view", {content:e,workId:this.workId});
      this.getIcv_view=e.src
    },
    getIcvImg(){
      var c = document.createElement("canvas");
      var cxt=c.getContext("2d");
      var img=new Image();
      img.setAttribute("crossOrigin",'Anonymous');
      img.src=this.icvImageUrl
      let that=this
      img.onload=function(){
          c.width = this.width;
          c.height = this.height;
          cxt.drawImage(img, 0, 0, this.width, this.height) // 在canvas上绘制图片
          var dataURL = compress(img,this.width,this.height,0.8);
          var newImg = new Image();
          newImg.src=dataURL
          that.$store.commit("setIcv_view",{content:newImg,workId:that.workId})
          setTimeout(()=>{
            console.log(that.$store.state.icv_view,that.$store.state.icv_exam)
          },500)
      }
    },
    getIcvExam(e) {
      console.log('接受setIcv_exam',e,this.workId)
      this.$store.commit("setIcv_exam", e);
      if(!JSON.parse(localStorage.getItem("setIcv_exam"))){
        localStorage.setItem("setIcv_exam", JSON.stringify(e.src))
      }
    },
    change() {
      //console.log(e)
      this.$forceUpdate();
    },
    periodChange(e) {
      console.log(this.chartOption,e)
      this.setShow = e;
      if(e==0){
        let obj=JSON.parse(JSON.stringify(this.chartOption))
        this.chartOption={}
        setTimeout(()=>{
          this.chartOption=obj
        },1)
      }
    },
    getIcvSection() {
      let params = {
        pileNum: this.ZHFirst * 1000 + this.ZHLast*1,
        workId: this.workId,
      };
      rollingQualityIcvSection(params).then((res) => {
        console.log(res);
        let getMap = res.data.content.info.subDataList;
        // let getMap = [
        //   {
        //     name: "第11遍",
        //     subDataMap: {
        //       0: 0.0,
        //       2: 80.0,
        //       4: 70.0,
        //       6: 85.0,
        //       8: 90.0,
        //       10: 95.0,
        //     },
        //   },
        //   {
        //     name: "第11遍",
        //     subDataMap: {
        //       0: 0.0,
        //       2: 80.0,
        //       4: 70.0,
        //       6: 85.0,
        //       8: 90.0,
        //       10: 95.0,
        //     },
        //   },
        // ];
        let getPass = res.data.content.info.passIcv;
        let xAxisList = [];
        if (getMap.length) {
          for (let key in getMap[0].subDataMap) {
            xAxisList.push(key);
          }
        }
        let passVal = [];
        for (let i = 0; i < xAxisList.length; i++) {
          passVal.push(getPass);
        }
        xAxisList = xAxisList.sort(function(x,y){return x-y});
        let series = [];
        series.push({
          name: "合格线",
          type: "line",
          data: passVal,
        });
        for (let i = 0; i < getMap.length; i++) {
          let getList = getMap[i].subDataMap;
          let yData = [];
          for (let key in getList) {
            console.log(key);
            yData.push(getList[key]);
          }
          let setObj = {
            name: getMap[i].name,
            type: "line",
            data: yData,
          };
          series.push(setObj);
        }
        this.$nextTick(()=>{
          this.chartOptionJ = Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              orient: 'vertical',
              right: 0,
              top: 30,
              itemWidth:12,
              itemHeight:8,
              textStyle:{
                  lineHeight:20,
              },
              padding:0,
              // data: legend,
            },
            grid: {
              bottom: 70,
              top: 30,
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "压实度",
                splitArea: {
                  show: true,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#878787",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            dataZoom: [
              {
                type: "slider",
                show: true,
                realtime: true,
                start: 0,
                end: 100,
                handleSize: "10%",
                height: 10,
                handleStyle: {
                  borderWidth: 2,
                },
                bottom: "5%",
              },
              {
                type: "inside",
                xAxisIndex: [0],
              },
              {
                type: "slider",
                yAxisIndex: [0],
                show: false,
                zoomLock: true,
              },
            ],
            series: series,
          }
        );
        })
        
      });
    },
    getData(res) {
      if(res==null)res={}
      console.log(res,"heartMap");
      res.max = res.max==undefined?null:res.max.toFixed(0);
      res.min = res.min==undefined?null:res.min.toFixed(0);
      res.average = res.average==undefined?null:res.average.toFixed(2);
      res.standardDiff = res.standardDiff==undefined?null:res.standardDiff.toFixed(2);
      res.passRate = res.passRate==undefined?null:(res.passRate * 100).toFixed(2) + "%";
      res.overRate = res.overRate==undefined?null:(res.overRate * 100).toFixed(2) + "%";
      res.lackRate = res.lackRate==undefined?null:(res.lackRate * 100).toFixed(2) + "%";
      this.leftData = res;
      res.data=res.data==undefined?[]:res.data
      // console.log(res);
      let xAxisObj = {};
      var xAxisData = res.data.map((item) => item[0]);
      // xAxisData.length = 100;
      var yAxisData = this.$store.state.roadWidth;
      xAxisData = unique(xAxisData);
      for (let i = 0; i < xAxisData.length; i++) {
        xAxisObj[xAxisData[i]] = i;
      }
      //console.log(xAxisObj);
      let data = [];
      const dataMap = {};
      res.data.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit
      for (let i = 0; i < res.data.length; i++) {
        let arr = [
          xAxisObj[res.data[i][0]],
          res.data[i][1] *10/(code*10),
          res.data[i][2].toFixed(0) * 1,
        ];
        data.push(arr);
      }

      // const colorBox = this.$store.state.icvColorArr.reverse();
      const colorBox =  JSON.parse(JSON.stringify(this.$store.state.icvColorArr)).reverse();
      let colorList = this.$store.state.icvColor;
      let keys = Object.keys(colorList);
      let setArr = []
      for(let i=0;i<keys.length;i++){
        setArr.push({
          min: keys[i-1]?keys[i-1]*1+1:0,
          max: keys[i]*1
        })
      }
      this.chartOption = {
        visualMap: {
          type: "piecewise",
          min: 0,
          max: 100,
          calculable: true,
          realtime: false,
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          show: false,
          pieces: setArr,
          color: colorBox,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "压实度",
            type: "heatmap",
            data: data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 0,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10%",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
      };
      this.JMShow = 1;
    },
  },
  components: {
    LeftList,
    // Rolling,
    heatMap,
    ChartLine,
    // ChartLine,
    // GridLayout,
     RollLegend
  },
};
</script>
<style  lang="scss">
.ZHSet {
  .el-input {
    margin: 0 10px;
    width: 120px;
    height: 35px;
    .el-input__inner {
      width: 120px;
      height: 35px;
      border: 1px solid #e1e1e1!important;
    }
  }
}
</style>
<style lang="scss" scoped="">
.noDateShow{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 640px;
  
}
.colorImg {
  position: absolute;
  border: 1px solid #e1e1e1;
  height: 121px;
  width: 360px;
  bottom: 50px;
  left: 0px;
  background-image: url("../../../../images/all/icvNum.png");
  background-size: 99.8% 99.5%;
}
.ly1-right {
  position: relative;
  .radioGroup {
    position: absolute;
    top: 10px;
    left: 130px;
    z-index: 99;
  }
  .ZHSet {
    position: absolute;
    height: 36px;
    line-height: 36px;
    width: 600px;
    font-size: 14px;
    // background-color: #ff0000;
    top: 10px;
    left: 450px;
    z-index: 99;
  }
}
.rollLegend{
    position: absolute;
    bottom: 50px;
    left: 0px;
}
.imgCon{
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  .checkDetail{
    width: 80px;
    height: 30px;
    // line-height: 30px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 99;
  }
  img{
    width: 100%;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.mapdialog{
  width: 1520px !important;
  .el-dialog__header{
    width: 1515px !important;
  }
  .el-dialog__body{
    width: 1515px !important;
    height: 520px !important;
  }
}
</style>